<template>
  <Icon icon="ic:baseline-close" class="list-deselect" />
</template>

<style scoped>
.vs__clear .list-deselect {
  @apply mx-1;
}
</style>
